export const formatNumber = (value: number | undefined): string => {
  if (value === undefined || value === null) return "0";
  return value % 1 === 0 ? value.toString() : value.toFixed(2);
};

export const formatSecondsToTime = (seconds: number | undefined): string => {
  if (seconds === undefined || seconds === null || seconds < 0) return "0:00";
  
  const roundedSeconds = Math.round(seconds);
  const minutes = Math.floor(roundedSeconds / 60);
  const remainingSeconds = roundedSeconds % 60;
  
  return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
};
